import cn from 'classnames';
import styles from './checkbox.module.scss';
import { AnswerType } from '../../../enums/answer-type.enum';

interface CheckboxPros {
	type: AnswerType | 'agreement'
	checked: boolean,
	customStyles: Record<string, any>
}

export default function Checkbox({ type, checked, customStyles }:CheckboxPros) {
	return <div 
		className={cn(styles[type as string], { [styles.checked]: checked })}
		style={checked ? { ...customStyles, backgroundClip: "content-box" } : {}}
	/>
}